import type { SVGProps } from 'react';
import { HopperIcon, type HopperIconName } from './icons';

export type IconName =
  | 'bell'
  | 'chevron-down'
  | 'friends'
  | 'heart'
  | 'location'
  | 'map'
  | 'offer'
  | 'profile'
  | 'route'
  | 'scan'
  | 'search'
  | 'sliders'
  | 'sparkle';

type IconProps = SVGProps<SVGSVGElement> & {
  name: IconName;
};

const ICON_NAME_MAP: Record<IconName, HopperIconName> = {
  bell: 'bell',
  'chevron-down': 'chevron-down',
  friends: 'users',
  heart: 'heart',
  location: 'pin',
  map: 'map',
  offer: 'offers',
  profile: 'profile',
  route: 'routes',
  scan: 'scan',
  search: 'search',
  sliders: 'sliders',
  sparkle: 'sparkle',
};

export function Icon({ name, ...props }: IconProps) {
  return <HopperIcon name={ICON_NAME_MAP[name]} {...props} />;
}
